var styleDataHash = "b836f392";
const injectCss = () => {
  var css = `.fT5YO,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.zRR-1{width:100%}[dir] .zRR-1{margin:8px auto 0}.zRR-1 .Lr3t-{height:1px}[dir] .zRR-1 .Lr3t-{background-color:var(--ricos-settings-dividers-color,rgba(51,51,51,.2))}@supports not (contain:inline-size){@media only screen and (max-width:640px){.zRR-1 .Lr3t-{width:100%}[dir] .zRR-1 .Lr3t-{margin:0}}}@container (width < 640px){.zRR-1 .Lr3t-{width:100%}[dir] .zRR-1 .Lr3t-{margin:0}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var list_item_section_default = {
  "fontElementMap": "fT5YO",
  "whitespace": "zRR-1",
  "divider": "Lr3t-"
};
export {
  list_item_section_default as default,
  injectCss
};
//# sourceMappingURL=list-item-section-scss.js.map
